module.exports = __webpack_public_path__ + "static/media/description.eac95257.svg";